import { render, staticRenderFns } from "./pay_edit.vue?vue&type=template&id=f12ed6e4&scoped=true&"
import script from "./pay_edit.vue?vue&type=script&lang=js&"
export * from "./pay_edit.vue?vue&type=script&lang=js&"
import style0 from "./pay_edit.vue?vue&type=style&index=0&id=f12ed6e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12ed6e4",
  null
  
)

export default component.exports